import './faq-item.component.scss'

document.querySelectorAll('.faq-item').forEach((root) => {
  const heading = root.querySelector('.faq-item__heading')
  const parent = root.parentElement
  heading.addEventListener('click', () => {
    Array.from(parent.querySelectorAll('.faq-item.is-active'))
      .filter((item) => item !== root)
      .forEach((faqItem) => faqItem.classList.remove('is-active'))
    root.classList.toggle('is-active')
  })
})
